import React from 'react';
import { HStack, Text, Select } from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';

type PaginationControlsProps = {
  pageSize: number;
  onPageSizeChange: (size: number) => void;
  totalItems: number;
  displayedCount: number;
  onShowMore: () => void;
  hasMore: boolean;
  pageSizeOptions?: number[];
  itemLabel?: string;
};

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const PaginationControls: React.FC<PaginationControlsProps> = ({
  pageSize,
  onPageSizeChange,
  totalItems,
  displayedCount,
  onShowMore,
  hasMore,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
  itemLabel = 'Results',
}) => {
  const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newSize = parseInt(e.target.value, 10);
    onPageSizeChange(newSize);
  };

  return (
    <HStack
      spacing={4}
      bg="surface.card"
      px={4}
      py={2}
      borderRadius="md"
      boxShadow="sm"
      border="1px solid"
      borderColor="border.layout">
      <HStack spacing={2}>
        <Text fontSize="14px" fontWeight={600} color="text.title">
          Show
        </Text>
        <Select
          size="sm"
          value={pageSize}
          onChange={handlePageSizeChange}
          w="70px"
          borderRadius="md"
          fontSize="14px">
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </Select>
        <Text fontSize="14px" color="darkGray">
          of{' '}
          <Text as="span" fontWeight={600} color="text.title">
            {totalItems}
          </Text>{' '}
          {itemLabel}
        </Text>
      </HStack>

      <Button
        buttonName="show-more"
        variant="outline"
        size="sm"
        onClick={onShowMore}
        borderColor="icon.green"
        color="text.title"
        fontSize="14px"
        fontWeight={600}
        isDisabled={!hasMore}
        _hover={{ bg: 'surface.greenHover' }}
        _disabled={{ opacity: 0.5, cursor: 'not-allowed' }}>
        Show More
      </Button>
    </HStack>
  );
};
